import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const getSupplierDetail = (state: AppState) => state.contactsAndOrganizations.suppliers.supplierDetail;

export const supplierCategoryMappingSelector = createSelector(
    getSupplierDetail,
    state => state.categories.supplierMappings
);
